/**
 * Persist collection context for PDP breadcrumb. Does not change product URLs.
 */
(function () {
  const KEY = 'cw_bc_collection';

  function save(data) {
    if (!data || !data.handle) return;
    try {
      sessionStorage.setItem(
        KEY,
        JSON.stringify({
          handle: data.handle,
          title: data.title || data.handle.replace(/-/g, ' '),
          url: data.url || '/collections/' + data.handle,
        })
      );
    } catch (e) {}
  }

  function stamp(handle, title, url) {
    document.querySelectorAll('product-card:not([data-cw-bc-handle])').forEach(function (card) {
      card.setAttribute('data-cw-bc-handle', handle);
      card.setAttribute('data-cw-bc-title', title);
      card.setAttribute('data-cw-bc-url', url);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;
      const source = event.target.closest('[data-cw-bc-handle]');
      if (!source) return;
      save({
        handle: source.getAttribute('data-cw-bc-handle'),
        title: source.getAttribute('data-cw-bc-title') || undefined,
        url: source.getAttribute('data-cw-bc-url') || undefined,
      });
    },
    true
  );

  const match = location.pathname.match(/^\/collections\/([^/?#]+)/);
  if (!match || location.pathname.includes('/products/')) return;

  const handle = match[1];
  let title = handle.replace(/-/g, ' ');
  let url = '/collections/' + handle;
  const el = document.getElementById('cw-bc-collection');
  if (el) {
    try {
      const parsed = JSON.parse(el.textContent || '{}');
      if (parsed.handle) {
        // Prefer Shopify collection.title ("Men's Shirts") over handle text
        title = parsed.title || title;
        url = parsed.url || url;
      }
    } catch (e) {}
  } else {
    const h1 = document.querySelector('h1');
    if (h1 && h1.textContent) title = h1.textContent.trim();
  }

  save({ handle: handle, title: title, url: url });
  stamp(handle, title, url);

  const grid = document.getElementById('ResultsList') || document.querySelector('results-list');
  if (grid) {
    new MutationObserver(function () {
      stamp(handle, title, url);
    }).observe(grid, { childList: true, subtree: true });
  }
})();
